import { Theme } from '@mui/material/styles';
import React from 'react';

// ==============================|| OVERRIDES - INPUT BASE ||============================== //

export default function InputBase(theme: Theme) {
  return {
    MuiInputBase: {
      defaultProps: {
        onFocus: (e: React.FocusEvent<HTMLInputElement>) => {
          if (e.target.type === 'number' || e.target.type === 'text') {
            e.target.select();
          }
        },
      },
      styleOverrides: {
        root: {
          fontSize: '0.75rem',
        },
        input: {
          // Hide number input spinner arrows (Chrome, Safari, Edge, Opera)
          '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
          // Hide number input spinner arrows (Firefox)
          '&[type=number]': {
            MozAppearance: 'textfield',
          },
        },
      }
    }
  };
}
